import React, { useEffect } from 'react';

/**
 * ADA-compliant custom confirm dialog — no browser confirm().
 * Usage: <ConfirmPopup open={bool} title="..." message="..." onConfirm={fn} onCancel={fn} variant="danger|warning" />
 */
export default function ConfirmPopup({ open, title, message, onConfirm, onCancel, variant = 'danger', confirmLabel = 'Confirm', cancelLabel = 'Cancel' }) {
  useEffect(() => {
    if (open) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  if (!open) return null;

  const iconColor = variant === 'danger' ? '#c81e1e' : '#b45309';
  const btnClass = variant === 'danger' ? 'btn-danger' : 'btn-warning';

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-popup-title"
      style={{
        position: 'fixed', inset: 0, zIndex: 9100,
        background: 'rgba(17,24,39,0.55)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '16px',
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onCancel?.(); }}
    >
      <div
        style={{
          background: '#fff', borderRadius: 12, maxWidth: 420, width: '100%',
          padding: '32px 28px 24px', boxShadow: '0 20px 60px rgba(0,0,0,.2)',
          textAlign: 'center',
        }}
      >
        <div style={{ marginBottom: 16 }}>
          <div style={{
            width: 56, height: 56, borderRadius: '50%', margin: '0 auto',
            background: variant === 'danger' ? '#fee2e2' : '#fef3c7',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <i
              className={variant === 'danger' ? 'bi bi-exclamation-triangle-fill' : 'bi bi-exclamation-circle-fill'}
              aria-hidden="true"
              style={{ fontSize: 26, color: iconColor }}
            />
          </div>
        </div>
        <h2 id="confirm-popup-title" style={{ fontSize: 18, fontWeight: 700, marginBottom: 8, color: '#111827' }}>
          {title || 'Are you sure?'}
        </h2>
        {message && <p style={{ color: '#6b7280', marginBottom: 24, lineHeight: 1.6 }}>{message}</p>}
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
          <button className="btn btn-outline-secondary" style={{ minWidth: 100 }} onClick={onCancel}>
            {cancelLabel}
          </button>
          <button className={`btn ${btnClass}`} style={{ minWidth: 100 }} onClick={onConfirm} autoFocus>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
